import { configGetCountry } from 'common/helper/config/get-country';

export function createAlertEnabled(): boolean {
  return ['ae'].includes(configGetCountry().code);
}
